import React from 'react';
import {
  Home as HomeIcon,
  ManageAccounts as ManageIcon,
  Insights as InsightIcon,
} from '@mui/icons-material';
import { RoleBasedConfig } from './routeTypes';
import { UserRole } from '@features/authentication/types';
import { commonNavigationItems, commonRoutes } from './commonRoutes';
import { DashboardRoutes } from '@features/dashboard';
import { ManageRoutes, ManageRouteGuard } from '@features/manage';
import { InsightRoutes } from '@features/insight';
import { ProtectedRoute } from '../ProtectedRoute';
import { Navigate } from 'react-router-dom';
import { UniversityAdminManageWrapper } from '@features/tenant';

export const universityAdminConfig: RoleBasedConfig = {
  navigation: {
    top: [
      {
        label: 'Dashboard',
        href: '/app/dashboard',
        icon: React.createElement(HomeIcon),
      },
      {
        label: 'Manage',
        href: '/app/manage',
        icon: React.createElement(ManageIcon),
      },
      {
        label: 'Insight',
        href: '/app/insight',
        icon: React.createElement(InsightIcon),
      },
    ],
    bottom: commonNavigationItems.bottom,
  },
  routes: [
    {
      path: 'dashboard',
      element: React.createElement(ProtectedRoute, null, React.createElement(DashboardRoutes)),
      protected: true,
      requiredRoles: [UserRole.UNIVERSITY_ADMIN],
    },
    {
      path: '',
      element: React.createElement(Navigate, { to: 'dashboard', replace: true }),
    },
    {
      path: 'manage',
      element: React.createElement(
        ProtectedRoute,
        null,
        React.createElement(UniversityAdminManageWrapper)
      ),
      protected: true,
      requiredRoles: [UserRole.UNIVERSITY_ADMIN],
    },
    {
      path: 'manage/*',
      element: React.createElement(
        ProtectedRoute,
        null,
        React.createElement(ManageRouteGuard, null, React.createElement(ManageRoutes))
      ),
      protected: true,
      requiredRoles: [UserRole.UNIVERSITY_ADMIN],
    },
    {
      path: 'insight/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(InsightRoutes)),
      protected: true,
      requiredRoles: [UserRole.UNIVERSITY_ADMIN],
    },
    ...commonRoutes,
  ],
};
